// Base types, constants and general interfaces for Settings contracts

// Platform constants (enum-like access)
export const NativePlatform = {
	WINDOWS: 'windows',
	LINUX: 'linux',
	MAC: 'mac',
	ANDROID: 'android',
	IOS: 'ios',
	HTML5: 'html5',
	CHROMEOS: 'chromeos',
} as const;

// Platform types
export type NativePlatformType = (typeof NativePlatform)[keyof typeof NativePlatform];

// Settings entry constants (enum-like access)
export const SettingsEntry = {
	ENDPOINT: 'Endpoint',
	SUPPORT_AND_TROUBLESHOOT: 'SupportAndTroubleshoot',
	IN_SESSION: 'InSession',
	ACCOUNT_MANAGEMENT: 'AccountManagement',
} as const;

// Settings entry types
export type SettingsEntryType = (typeof SettingsEntry)[keyof typeof SettingsEntry];

// Response status codes
export type StatusCode = 0 | 1; // Success: 0, Failure: 1
